import { addToCart } from "../redux/cartRedux";
import { withOutletQuery } from "./vendorOutlets";

// ─────────────────────────────────────────────────────────────────────────────
// "Unified browse, segregated carts"
//
// The /shop grid merges every vendor type for DISCOVERY, but the platform keeps
// a separate cart + checkout per vendor type (each enforces its own COD / MOQ /
// tier-pricing / delivery rules). So each product's Add-to-cart is routed to the
// correct destination:
//
//   • inhouse              → added straight to the in-house grocery cart (cartRedux)
//   • retailer / wholesaler → opens that vendor's storefront, where its cart +
//                             vendor-switch guard already live
//   • brand                → opens that brand's storefront
//
// Returns { added, label } so the caller can show the right toast / button state.
// ─────────────────────────────────────────────────────────────────────────────

export const isInhouse = (p) => p?.vendorType === "inhouse";

// The storefront a retailer, wholesaler or brand product opens, or null.
// One builder, so the tap and the card's link (which search engines follow)
// always name the same page.
export const catalogStorePath = (product) => {
  if (!product || !product.vendorId) return null;
  const vt = product.vendorType;
  if (vt === "retailer" || vt === "wholesaler") return `/shop/${product.vendorId}`;
  if (vt === "brand") {
    // A product listed under a brand OUTLET opens that outlet's storefront
    // (`?outletId=`), so the hours, coverage and fee the shopper then sees,
    // and the outlet every cart line names, are the outlet's.
    return withOutletQuery(`/brand/shop/${product.vendorId}`, product.outletId || null);
  }
  return null;
};

export const handleCatalogAdd = (product, { dispatch, history } = {}) => {
  if (!product) return { added: false, label: "" };
  const vt = product.vendorType;

  if (vt === "inhouse") {
    dispatch(
      addToCart({
        item: {
          _id: product._id,
          title: product.name,
          price: product.price,
          product_image: product.image || product.product_image,
          countInStock: product.countInStock,
          creator: product.vendorId,
          unit_id:
            product.unit_id && product.unit_id._id
              ? product.unit_id
              : { _id: null, unit: product.unit_id?.unit || "" },
        },
      })
    );
    return { added: true, label: "Added to cart" };
  }

  if (vt === "retailer" || vt === "wholesaler" || vt === "brand") {
    const path = catalogStorePath(product);
    if (history && path) history.push(path);
    return { added: false, label: "Visit store" };
  }

  return { added: false, label: "" };
};

// Human label for a vendor type (badge text fallback).
export const vendorTypeLabel = (vt) =>
  ({
    inhouse: "Lusuku",
    retailer: "Retailer",
    wholesaler: "Wholesaler",
    brand: "Brand",
  }[vt] || "Vendor");
